import "./Footer.css";
import React from "react";

export const Footer = () => {
  return React.createElement(
    "footer",
    { className: "footer" },
    React.createElement(
      "div",
      { className: "footer-container" },
      // Company Column
      // Support Column
      // Contact Column
      React.createElement(
        "div",
        { className: "footer-column" },
        React.createElement("h4", null, "Contact Us"),
        React.createElement(
          "ul",
          null,
          [
            React.createElement(
              "li",
              { key: "contact-link" },
              React.createElement(
                "a",
                { href: "Suryasalescompany.spd@gmail.com", target: "_blank" },
                "motatecasiallp@gmail.com"
              )
            ),
            React.createElement("li", { key: "contact-email" }, "Surya Sales +91"),
            React.createElement("li", { key: "contact-address" }, "Gurgaon"),
          ]
        )
      )
    ),
    // Horizontal Line
    React.createElement("div", { className: "footer-line" }),
    // Bottom Footer
    React.createElement(
      "div",
      { className: "footer-bottom" },
      React.createElement("p", null, "MotatecAsia © 2025"),
      React.createElement(
        "a",
        { href: "", target: "_blank" },
        React.createElement(
          "p",
          { className: "my-name" },
          React.createElement("i", { className: "ri-sparkling-2-fill" }),
          "Created By Shubham Nayak"
        )
      )
    )
  );
};
